import {CALCULATOR_TYPES, defaultStepsState, getCalculatorType, hasShareParam, remapObject} from "./helpers";
import {currencyToNumber} from "./helpers";
import {parseSearchQuery} from "../store/actions/calculatorActions";

// update every time the state structure changes
const stateVersion = '16052024';

const mappingValuesState = [
  'MortgageType',
  'RentevastePeriode',
  'Interest',
  'MortgageParts', //[]
  'response',
  'SelectedMortgageProvider', // alleen product id opslaan
  'ApplicantAge',
  'ApplicantYearlyIncome',
  'ApplicantAnnualPensionIncome',
  'ApplicantAOW',
  'HasPartner',
  'PartnerAge',
  'PartnerYearlyIncome',
  'PartnerAnnualPensionIncome',
  'PartnerAOW',
  'HasLoans',
  'Loans',
  'RiskClass',
  'Alimony',
  'StudentDebtAmount',
  'Woning',
  'IsNieuwbouw',
  'HasHouse',
  'HomeEquity',
  'HomeEquityCosts',
  'HomeMortgageAmount',
  'HomeMortgageStart',
  'HomeMortgageStartNotKnown',
  'HomeMortgageStartBefore2013',
  'HomeMortgageIsBeingPaidOff',
  'HomeMortgageOtherPartAmount',
  'OwnResources',
  'PrivateLeaseAmount',
  'WantsToSkipMortgageQuestions',
  'SustainabilityUplift',
  'EnergyLabel',
];

const stepFields = [
  // step 1
  "ApplicantAge",
  "ApplicantYearlyIncome",
  "ApplicantAnnualPensionIncome",
  "ApplicantAOW",
  "HasPartner",
  "PartnerAge",
  "PartnerYearlyIncome",
  "PartnerAnnualPensionIncome",
  "PartnerAOW",
  // step 2
  "HasLoans",
  "Loans",
  "Alimony",
  "StudentDebtAmount",
  "PrivateLeaseAmount",
  // step 3
  "Woning",
  "IsNieuwbouw",
  // step 4
  "HomeEquity",
  "OwnResources",

];


export const getInitialState = () => {

  let defaultState = {};
  defaultState = {
    MortgageType: "Annuïteitenhypotheek",
    RentevastePeriode: 10,
    Interest: 0,
    MortgageParts: [],
    IsNieuwbouw: 0,
    response: {
      maxMortgageAmount: 0,
      interest: 0,
      grossMonthlyCostHouse: 0,
      netMonthlyCostHouse: 0,
      extraMoneyNeeded: 0
    },
    sharePdf: {
      state: 'not_mailed',
      success: null,
      message: false
    },
    stepState: defaultStepsState,
    SelectedMortgageProvider: false,
    stepNumber: 0
  };

  stepFields.forEach((item) => {
    defaultState[item] = 0;
  });

  const shareParam = hasShareParam()

  if (shareParam) {
    defaultState = {...defaultState, ...getStateFromBase64(shareParam, mappingValuesState)};
  } else {

    // check for stateVersion
    if (window.localStorage.getItem('state.version') !== stateVersion) {
      window.localStorage.removeItem(`state.${CALCULATOR_TYPES.hoeveelKanIkLenen}`)
      window.localStorage.removeItem(`state.${CALCULATOR_TYPES.watWordenMijnMaandLasten}`)
      window.localStorage.removeItem(`state.${CALCULATOR_TYPES.kanIkDitHuisBetalen}`)
      window.localStorage.setItem(`state.version`, stateVersion);
    }
    // and check for session state
    const storedState = window.localStorage.getItem(`state.${getCalculatorType()}`)
    if (storedState) {
      defaultState = {
        ...defaultState,
        ...getStateFromBase64(storedState, mappingValuesState)
      }
    };

    // check if there are any request params, if so we need to add them to the default state
    const requestParams = parseSearchQuery(window.location.search, true);
    const paramsState = remapObject(requestParams, {
      Klant_Jaarinkomen: "ApplicantYearlyIncome",
      Klant_Leeftijd: "ApplicantAge",
      Partner_Jaarinkomen: "PartnerYearlyIncome",
      Partner_Leeftijd: "PartnerAge",
      HeeftPartner: "HasPartner",
      Onderpand_Koopsom: "Woning",
      Onderpand_IsNieuwbouw: "IsNieuwbouw",
      Heeft_Woning: "HasHouse",
      Overslaan_Hypotheek: "WantsToSkipMortgageQuestions",
      Huis_Prijs: "HomeEquity",
      Verkoop_Kosten: "HomeEquityCosts",
      Hoogte_Hypotheek: "HomeMortgageAmount",
      Student_Debt_Amount: "StudentDebtAmount"
    })

    if (requestParams?.Onderpand_IsNieuwbouw || requestParams?.isnewbuilding) {
      paramsState.IsNieuwbouw = paramsState.IsNieuwbouw === 'true' || requestParams?.isnewbuilding === "true" ? 2 : 1;
    }

    if (requestParams?.energylabel) {
      paramsState.EnergyLabel = {value: requestParams.energylabel, label: requestParams.energylabel}
    }

    if (Object.keys(paramsState).length) {
      defaultState = {
        ...defaultState,
        ...paramsState
      }
    }

  }

  return defaultState;

}

export function saveStateToSession(state, calculatorType) {
  window.localStorage.setItem(
      `state.${calculatorType}`,
      getBase64FromState(state, mappingValuesState)
  );
}

// create share link, to send to bitly
export function getStateAsShareableLink(state) {

  const { origin, pathname, hostname} = window.location;
  let domain = `${origin}${pathname}?share=${getBase64FromState(state, mappingValuesState)}`;
  if (hostname.indexOf('localhost') !== -1) {
    domain += `&type=${getCalculatorType()}`
  } else {
    //console.log(domain);
  }
  return domain;
}

//  internal functions
const encodeMortgageParts = (mortgageParts) => {
  const mortgagePartsToString = [];
  if (mortgageParts.length) {
    mortgageParts.forEach((mortgagePart) => {
      mortgagePart.mortgageType = Object.values(mortgagePart.mortgageType).join('#');
      mortgagePart.currentMortgageAmount = currencyToNumber(mortgagePart.currentMortgageAmount)
      mortgagePart.fixedInterestAmount = currencyToNumber(mortgagePart.fixedInterestAmount);
      mortgagePartsToString.push(Object.values(mortgagePart).join('|'));
    });
  }

  return mortgagePartsToString;
}

const decodeMortgageParts = (mortgageParts) => {
  const mappingValuesMortgageParts = [
    'mortgageDate',
    'currentMortgageInterest',
    'fixedInterestYears',
    'fixedInterestAmount',
    'currentMortgageAmount',
    'mortgageType',
    'takeMortgage'
  ];

  const reconstructedMortgageParts = [];
  if (mortgageParts.length) {
    mortgageParts.forEach((mortgagePart) => {
      const mortgagePartArray = mortgagePart.split('|');
      let mortgagePartObject = {};
      mortgagePartArray.forEach((value, index) => {
        switch (mappingValuesMortgageParts[index]) {
          case "mortgageType":
            mortgagePartObject = {...mortgagePartObject, ...{[mappingValuesMortgageParts[index]] : {'value': mortgagePartArray[index].split('#')[0], 'label' : mortgagePartArray[index].split('#')[1]}}}
            break;
          default:
            mortgagePartObject = {...mortgagePartObject, ...{[mappingValuesMortgageParts[index]] : mortgagePartArray[index] }}
            break;
        }
      })
      reconstructedMortgageParts.push(mortgagePartObject);
    });
  }
  return reconstructedMortgageParts;
}

const getBase64FromState = (state, mappingValues) => {

  let valuesArray = [];

  // foreach stateMapping array and pick values from state
  mappingValues.forEach((value, index) => {

    switch (value) {
      case "MortgageType":
        valuesArray.push((state.MortgageType === "Annuïteitenhypotheek" || state.MortgageType === "Annuiteitenhypotheek") ? 4 : 9)
        break;
      case "MortgageParts":
        valuesArray.push(encodeMortgageParts(state.MortgageParts))
        break;
      case "response":
        valuesArray.push({riskClass: state.response?.riskClass, isNhg: state.response?.isNhg, maxMortgageAmount: state.response?.maxMortgageAmount});
        break;
      case "SelectedMortgageProvider":
        valuesArray.push((state.SelectedMortgageProvider) ? state.SelectedMortgageProvider.lookupId : false)
        break;
      default:
        valuesArray.push(state[value])
        break
    }
  })

  //console.log(valuesArray);
  return btoa(JSON.stringify(valuesArray));
}

const getStateFromBase64 = (base64State, mappingValues) => {
  const decodedStateValues = JSON.parse(atob(base64State));
  let reconstructedState = {};
  mappingValues.forEach((value, index) => {
    switch (value) {
      case "MortgageType":
        reconstructedState = {...reconstructedState, ...{[value]: (decodedStateValues[index] === 4) ? 'Annuïteitenhypotheek' : 'Lineaire_hypotheek' }};
        break;
      case "MortgageParts":
        reconstructedState = {...reconstructedState, ...{[value]: decodeMortgageParts(decodedStateValues[index]) }};
        break;
      default:
        reconstructedState = {...reconstructedState, ...{[value]: decodedStateValues[index]}};
        break;
    }
  });

  return reconstructedState;

}
